import style from "./style.module.scss"

import { numberToYearsInRussian } from "utils/infrastructure/wording-utils"
import { HelpTooltip } from "components"
import { Text } from "ui-kit/components-branded/Text"
import { useMaxExperience } from "utils/hooks"
import { Psychologist } from "utils/interfaces"

export const Experience = ({ psy }: { psy: Psychologist }) => {
    const { experience } = useMaxExperience(psy)
    return (
        <div className={style.container} data-testid="psy-profile-experience">
            {psy.age && (
                <>
                    <div>
                        <Text className={style.age}>
                            {psy.age}&nbsp;{numberToYearsInRussian(psy.age)}
                        </Text>
                    </div>
                    <div className={style.dots}>
                        <div className={style.dotsInner} />
                    </div>
                </>
            )}
            <div className={style.experienceWrapper}>
                <Text className={style.experience}>
                    {experience < 1
                        ? "Опыт до 1 года"
                        : `${experience} ${numberToYearsInRussian(experience)} опыта`}
                </Text>
                <HelpTooltip
                    overlay={
                        <div data-testid="psy-profile-experience-modal">
                            <div>
                                {psy.experience < 1
                                    ? "Опыт до 1 года"
                                    : `${psy.experience} ${numberToYearsInRussian(psy.experience)}`}
                                &nbsp;&mdash; с&nbsp;момента окончания долгосрочной программы
                                по&nbsp;основному подходу
                            </div>
                            {!!psy.private_experience && psy.private_experience > 0 && (
                                <div>
                                    {psy.private_experience}&nbsp;
                                    {numberToYearsInRussian(psy.private_experience)}&nbsp;&mdash;
                                    общий опыт работы психологом
                                </div>
                            )}
                        </div>
                    }
                    placement="topLeft"
                />
            </div>
        </div>
    )
}
